import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcPil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      transform="translate(9 3)"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
    >
      <rect x={1} y={1} width={13} height={24} rx={6.5} />
      <path d="M3 13h9" />
    </g>
  </svg>
);
export default SvgIcPil;
